import { render } from "./Dispatcher.vue?vue&type=template&id=76225ff1"
import script from "./Dispatcher.vue?vue&type=script&lang=js"
export * from "./Dispatcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__